<template>
    <div>
       
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        name: 'pImportItems',
        props: ['igvGlobal','item','action','itemsEX','itemsEXz'],
        data: () => {
            return {
                preitem: {},
                preitemz: {},
                items: [],
                montoValorUnitario2:'',
                montoIgvGlobal:'',
                inafecto:'',
                preitemg:{},
                adicional: {
                    indicardorDsct:'',
                    dsctSoles:'',
                    dsctPorcentaje:'',
                    precioVentaUni:'',
                },
                unoDieciocho:1.18,
                ceroDieciocho:0.18,
                dieciocho:18,
                // unoUno:1.1,
                // ceroUno:0.1,
                // diez:10,
                unoUno:1.105,
                ceroUno:0.105,
                diez:10.5,
            }
        },
        mounted() {
            // this.almacenarIGV();
            this.initPreItem();
            this.initPreItemG();
        },
        watch: {
            'action.g': function () {
                if(this.action.g){   
                    for( let i = 0; i<this.itemsEX.length; i++){ 
                        this.completeItemG(i)
                    }
                }          
            },
            'action.i': function () {
                if(this.action.i){   
                    for( let i = 0; i<this.itemsEX.length; i++){ 
                        this.completeItem(i)
                    }
                }          
            },
            'action.z': function () {
                if(this.action.z){   
                    for( let i = 0; i<this.itemsEXz.length; i++){ 
                        this.completeItemZ(i)
                    }
                }          
            },
            'action.reset': function () {
                if(this.action.reset){
                    this.items = []
                }   
            }
        },
        methods: {
            initPreItemG(){
                this.preitemg = {
                    cantidad:'',
                    unidadMedida:'',
                    codigoItem:'',
                    descripcion:'',
                    codigoProductoSunat:'',
                    codigoProductoGs1:''
                }
            },
            initPreItem: function () {       
                this.preitem = {
                    tipoAfectacionIgv: '',
                    codigoTributo: '',
                    idProducto: '',
                    codigoProductoSunat: '',
                    unidadMedidaCantidad: '',
                    cantidad: '',
                    descripcion: '',
                    valorUnitario: '',
                    tipoPrecioVentaUnitario: '',
                    descuento: '',
                    porcentajeDescuento:0,
                    baseAfectacionIgv: '',
                    valorUnitarioVista: '',
                    valorVenta: '',
                    valorVentaVista: '',
                    porcentajeImpuesto: '',
                    montoAfectacionIgv: '',
                    montoTotalImpuestosItem: '',
                    precioVentaUnitario: '',
                    adicional: {
                        indicardorDsct:'',
                        dsctSoles:'',
                        dsctPorcentaje:'',
                        precioVentaUni:'',
                    },
                    cargosDescuentosItem:[{}]
                }
            },
            convertExceltoJson: function () {
                // Funcion para la carga masiva de items
            },
            completeItemG(i){
                this.preitemg.cantidad = parseFloat(this.itemsEX[i].cantidad)
                this.preitemg.unidadMedida = this.itemsEX[i].unidadMedida
                this.preitemg.codigoItem = this.itemsEX[i].codigoItem
                this.preitemg.codigoItem = this.itemsEX[i].codigo
                this.preitemg.codigoProductoSunat = this.itemsEX[i].codigoProductoSunat
                this.preitemg.codigoProductoGs1 =  this.itemsEX[i].codigoProductoGs1
                this.preitemg.descripcion = this.itemsEX[i].descripcion
              

                this.items.unshift(this.preitemg)
                this.initPreItemG()
                this.getItems(this.items)
            },
            completeItem: function (i) {  
                if(this.itemsEX){
                    this.preitem.cantidad = parseFloat(this.itemsEX[i].cantidad)
                    if(this.itemsEX[i].codigo == null){ // caso unico para duplicar guia a Factura
                        
                    }else{
                        this.preitem.codigoProducto = this.itemsEX[i].codigo.toString()
                    }
                    if(this.itemsEX[i].precioUnitario == null){// caso unico para duplicar guia a Factura
                        this.itemsEX[i].precioUnitario = '0'  
                    }
                    if(this.itemsEX[i].unidadMedida == null){
                        this.itemsEX[i].unidadMedida = 'NIU'
                    }
                    this.preitem.unidadMedidaCantidad = this.itemsEX[i].unidadMedida
                    this.preitem.descripcion = this.itemsEX[i].descripcion
                    this.preitem.tipoPrecioVentaUnitario = '01'
                    this.preitem.descuento = 0
                    if(this.itemsEX[i].codigo == null ){
                        this.preitem.idProducto = '-'
                    }else if(this.itemsEX[i] && this.itemsEX[i].idProducto){
                        this.preitem.idProducto = this.itemsEX[i].idProducto
                    }else{
                        this.preitem.idProducto = '-'
                    } 
                    this.preitem.valorVenta = this.itemsEX[i].precioUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                    this.preitem.precioVentaUnitario = parseFloat(this.itemsEX[i].precioUnitario)
                    this.preitem.adicional.precioVentaUni = parseFloat(this.itemsEX[i].precioUnitario)
                    if(this.itemsEX[i].tipoAfectacionIgv == '0'){ // caso unico para duplicar guia a Factura
                        this.itemsEX[i].tipoAfectacionIgv = '10'   
                    }
                    if(this.itemsEX[i].tipoAfectacionIgv=='10' || this.itemsEX[i].tipoAfectacionIgv=='01'){
                        this.preitem.tipoAfectacionIgv = '10'
                        this.preitem.codigoTributo = '1000'
                        this.preitem.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
                        this.preitem.valorUnitario = this.itemsEX[i].precioUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                        this.preitem.valorUnitarioVista =  this.itemsEX[i].precioUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                        this.preitem.baseAfectacionIgv = parseFloat(this.preitem.valorUnitario*this.preitem.cantidad) 
                        this.preitem.montoAfectacionIgv = this.preitem.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); // 0.18
                        if(this.itemsEX[i].descuento > 0){                      
                            this.preitem.adicional.indicardorDsct = '01'
                            this.preitem.adicional.dsctSoles = this.itemsEX[i].descuento

                            this.preitem.valorVentaSinAfectar = this.preitem.valorUnitario * this.preitem.cantidad
                            this.preitem.descuento = parseFloat(parseFloat(this.itemsEX[i].descuento / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(10)) //1.18
                            this.preitem.porcentajeDescuento = parseFloat(this.itemsEX[i].descuento / (this.$store.state.igv == 18 ? 1.18 : 1.105)) / this.preitem.valorVentaSinAfectar //1.18
                            this.preitem.baseAfectacionIgv = this.preitem.valorUnitario * this.preitem.cantidad - this.preitem.descuento
                            this.preitem.montoAfectacionIgv = this.preitem.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105) //0.18
                            
                            
                            this.montoValorUnitario2 = ( this.preitem.valorUnitario - (this.preitem.descuento/this.preitem.cantidad)); 
                            this.montoIgvGlobal = this.montoValorUnitario2 * (this.$store.state.igv == 18 ? 0.18 : 0.105); // 0.18
                            this.preitem.precioVentaUnitario = this.montoValorUnitario2 + this.montoIgvGlobal;
                            this.preitem.cargosDescuentosItem[0].indicador= "descuento";
                            (this.preitem.cargosDescuentosItem[0].codigoCargoDescuento= "00");
                            (this.preitem.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(this.preitem.porcentajeDescuento).toFixed(5)));
                            this.preitem.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(this.preitem.valorVentaSinAfectar).toFixed(2));
                            this.preitem.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(this.preitem.porcentajeDescuento * this.preitem.valorVentaSinAfectar).toFixed(2));
                        }else{
                            delete this.preitem.cargosDescuentosItem
                        }
                   }
                //   separacio  
                    else if(this.itemsEX[i].tipoAfectacionIgv=='20' || this.itemsEX[i].tipoAfectacionIgv=='02'){
                        this.preitem.tipoAfectacionIgv = '30'
                        this.preitem.codigoTributo = '9998'
                        this.preitem.porcentajeImpuesto = parseInt(0)
                        this.preitem.valorUnitario = this.itemsEX[i].precioUnitario
                        this.preitem.valorUnitarioVista = this.itemsEX[i].precioUnitario
                        this.preitem.baseAfectacionIgv = parseFloat(this.preitem.valorUnitario*this.preitem.cantidad)  
                        this.preitem.montoAfectacionIgv = parseFloat(0.00) 

                        if(this.itemsEX[i].descuento > 0){
                            this.preitem.adicional.indicardorDsct = '01'
                            this.preitem.adicional.dsctSoles = this.itemsEX[i].descuento

                            this.preitem.valorVentaSinAfectar = (this.preitem.valorUnitario) * this.preitem.cantidad
                            this.preitem.descuento = parseFloat(parseFloat(this.itemsEX[i].descuento).toFixed(10));
                            this.inafecto = (this.preitem.valorVentaSinAfectar - this.preitem.descuento)/this.preitem.cantidad;
                            this.preitem.porcentajeDescuento = parseFloat(this.itemsEX[i].descuento) / this.preitem.valorVentaSinAfectar;
                            this.preitem.baseAfectacionIgv = this.preitem.valorUnitario * this.preitem.cantidad - this.preitem.descuento
                             
                            this.preitem.precioVentaUnitario = this.inafecto; 
                            this.preitem.cargosDescuentosItem[0].indicador = "descuento";
                            (this.preitem.cargosDescuentosItem[0].codigoCargoDescuento = "00");
                            (this.preitem.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(this.preitem.porcentajeDescuento).toFixed(5)));
                            this.preitem.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(this.preitem.descuento).toFixed(2));
                            this.preitem.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(this.preitem.valorVentaSinAfectar).toFixed(2));
                        }else{
                            delete this.preitem.cargosDescuentosItem
                        }
                    }
                // separacion
                    else if(this.itemsEX[i].tipoAfectacionIgv=='30'|| this.itemsEX[i].tipoAfectacionIgv=='03'){
                        this.preitem.tipoAfectacionIgv = '20'
                        this.preitem.codigoTributo = '9997'
                        this.preitem.porcentajeImpuesto = parseInt(0)
                        this.preitem.valorUnitario = this.itemsEX[i].precioUnitario
                        this.preitem.valorUnitarioVista = this.itemsEX[i].precioUnitario
                        this.preitem.baseAfectacionIgv = parseFloat(this.preitem.valorUnitario*this.preitem.cantidad)  
                        this.preitem.montoAfectacionIgv = parseFloat(0.00) 
                        if(this.itemsEX[i].descuento > 0){
                            this.preitem.adicional.indicardorDsct = '01'
                            this.preitem.adicional.dsctSoles = this.itemsEX[i].descuento

                            this.preitem.valorVentaSinAfectar = (this.preitem.valorUnitario) * this.preitem.cantidad
                            this.preitem.descuento = parseFloat(parseFloat(this.itemsEX[i].descuento).toFixed(10));
                            this.inafecto = (this.preitem.valorVentaSinAfectar - this.preitem.descuento)/this.preitem.cantidad;
                            this.preitem.porcentajeDescuento = parseFloat(this.itemsEX[i].descuento) / this.preitem.valorVentaSinAfectar;
                            this.preitem.baseAfectacionIgv = this.preitem.valorUnitario * this.preitem.cantidad - this.preitem.descuento
                             
                            this.preitem.precioVentaUnitario = this.inafecto; 
                            this.preitem.cargosDescuentosItem[0].indicador = "descuento";
                            (this.preitem.cargosDescuentosItem[0].codigoCargoDescuento = "00");
                            (this.preitem.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(this.preitem.porcentajeDescuento).toFixed(5)));
                            this.preitem.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(this.preitem.descuento).toFixed(2));
                            this.preitem.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(this.preitem.valorVentaSinAfectar).toFixed(2));
                        }else{
                            delete this.preitem.cargosDescuentosItem
                        }

                    }

                    this.preitem.montoTotalImpuestosItem = parseFloat(this.preitem.montoAfectacionIgv)
                    this.preitem.valorVenta = this.preitem.baseAfectacionIgv
                    if(this.itemsEX[i].descuento !=0){
                        this.preitem.valorVentaVista = parseFloat(this.preitem.valorUnitario) * parseFloat(this.preitem.cantidad)- this.preitem.descuento
                    }else{
                        this.preitem.valorVentaVista = parseFloat(this.preitem.valorUnitario) * parseFloat(this.preitem.cantidad)
                    }
                    this.items.unshift(this.preitem)
                    this.initPreItem()
                    this.getItems(this.items)
                }
            },
            initPreItemz: function () {
                this.preitemz = {
                    afectoIcbper: '',
                    baseAfectacionIgv: '',
                    cantidad: '',
                    idProducto:'',
                    // cargosDescuentosItem: '',
                    codigoProducto: '',
                    // codigoProductoGs1: '',
                    codigoProductoSunat:'',
                    codigoTributo: '',
                    descripcion: '',
                    descuento: '',
                    idBoleta: '',
                    idBoletaItem: '',
                    iscOtrosTributosItem: '',
                    montoAfectacionIgv: '',
                    montoTotalImpuestosItem: '',
                    porcentajeDescuento: '',
                    porcentajeImpuesto: '',
                    precioVentaUnitario: '',
                    tipoAfectacionIgv: '',
                    tipoPrecioVentaUnitario: '',
                    unidadMedidaCantidad: '',
                    valorUnitario: '',
                    valorVenta: '',
                    adicional: {
                        indicardorDsct:'',
                        dsctSoles:'',
                        dsctPorcentaje:'',
                        precioVentaUni:'',
                    },
                    // cargosDescuentosItem:[{}]
                }
            },
            completeItemZ(i){
              if(this.itemsEXz){
                if(this.itemsEXz[i].idProducto !=null && this.itemsEXz[i].idProducto !='' && this.itemsEXz[i].idProducto !='-'){
                    this.preitemz.idProducto = this.itemsEXz[i].idProducto
                }else{
                    this.preitemz.idProducto = '-'
                } 
                this.preitemz.afectoIcbper = false
                this.preitemz.baseAfectacionIgv = parseFloat(this.itemsEXz[i].baseAfectacionIgv)
                this.preitemz.cantidad = parseFloat(this.itemsEXz[i].cantidad)
                // if(this.itemsEXz[i].cargosDescuentosItem != null && this.itemsEXz[i].cargosDescuentosItem != '' && this.itemsEXz[i].cargosDescuentosItem.length > 0 && this.itemsEXz[i].cargosDescuentosItem != '[]'){
                //     this.preitemz.cargosDescuentosItem = this.itemsEXz[i].cargosDescuentosItem
                // }
                if(this.itemsEXz[i].codigoProducto && this.itemsEXz[i].codigoProducto != ''){
                   this.preitemz.codigoProducto = this.itemsEXz[i].codigoProducto
                }else{
                    delete this.preitemz.codigoProducto
                }
                this.preitemz.codigoProductoGs1 = this.itemsEXz[i].codigoProductoGs1
                this.preitemz.codigoProductoSunat = this.itemsEXz[i].codigoProductoSunat
                this.preitemz.codigoTributo = this.itemsEXz[i].codigoTributo
                this.preitemz.descripcion = this.itemsEXz[i].descripcion
                if((this.itemsEXz[i].descuento)!= null){
                    this.preitemz.descuento = parseFloat(this.itemsEXz[i].descuento)
                }else{
                    this.preitemz.descuento = 0
                }
                this.preitemz.idBoleta = this.itemsEXz[i].idBoleta
                this.preitemz.idBoletaItem = this.itemsEXz[i].idBoletaItem
                if(this.itemsEXz[i].iscOtrosTributosItem != null && this.itemsEXz[i].iscOtrosTributosItem !=''){
                    this.preitemz.iscOtrosTributosItem = this.itemsEXz[i].iscOtrosTributosItem
                }else{
                    delete this.preitemz.iscOtrosTributosItem
                }
                this.preitemz.montoAfectacionIgv = parseFloat(this.itemsEXz[i].montoAfectacionIgv)
                this.preitemz.montoTotalImpuestosItem = parseFloat(this.itemsEXz[i].montoTotalImpuestosItem)
                this.preitemz.porcentajeDescuento = parseFloat(this.itemsEXz[i].porcentajeDescuento)
                this.preitemz.porcentajeImpuesto = parseFloat(this.itemsEXz[i].porcentajeImpuesto)
                this.preitemz.precioVentaUnitario = parseFloat(this.itemsEXz[i].precioVentaUnitario)
                this.preitemz.tipoAfectacionIgv = this.itemsEXz[i].tipoAfectacionIgv
                this.preitemz.tipoPrecioVentaUnitario = this.itemsEXz[i].tipoPrecioVentaUnitario
                this.preitemz.unidadMedidaCantidad = this.itemsEXz[i].unidadMedidaCantidad
                this.preitemz.valorUnitario = parseFloat(this.itemsEXz[i].valorUnitario)
                this.preitemz.valorVenta = parseFloat(this.itemsEXz[i].valorVenta)
                if(JSON.parse(this.itemsEXz[i].adicional) && JSON.parse(this.itemsEXz[i].adicional) != ''){
                    this.preitemz.adicional = JSON.parse(this.itemsEXz[i].adicional)
                }else{
                     this.preitemz.adicional =  this.adicional
                }
                this.items.unshift(this.preitemz)
                this.getItems(this.items)
                this.initPreItemz()
              }  
            },
            getItems: function (data) {
                this.$emit("totalitems", data);
            }
        }  
    }
</script>

<style>

</style>